import React from 'react';

import {
  Box,
  Grid,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  baseTypes,
  DownloadableResourceBox,
  ExternalLink,
  legalDocumentsDataService
} from 'modules';



interface IProps {
  apiFileData: baseTypes.IApiFileData[]
}

export const FC: React.FC<IProps> = props => {
  const getApiFileData = React.useCallback((title: legalDocumentsDataService.TermSheet) => {
    return _.find(props.apiFileData, data => data.title === title);
  }, [props.apiFileData]);



  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <DownloadableResourceBox.FC
            title="Equity"
            description={
              <Typography>
                For reference or more details, check out NVCA"s site&nbsp;
                <ExternalLink.Text href="https://nvca.org/model-legal-documents/">here</ExternalLink.Text>
                .
              </Typography>
            }
            thumbnailFilename="legal_nvca_equity_term_sheet.png"
            apiFileData={getApiFileData('Equity Term Sheet')}
            height={240}
            layoutVariant="document" />
        </Grid>

        <Grid item xs={4}>
          <DownloadableResourceBox.FC
            title="Convertible Debt"
            description={
              <Typography>
                For reference or more details, check out Cooley's site&nbsp;
                <ExternalLink.Text href="https://www.cooleygo.com/documents/">here</ExternalLink.Text>
                .
              </Typography>
            }
            thumbnailFilename="legal_convertible_note.png"
            apiFileData={getApiFileData('Convertible Debt Term Sheet')}
            height={240}
            layoutVariant="document" />
        </Grid>

        <Grid item xs={4}>
          <DownloadableResourceBox.FC
            title="SAFE Note"
            description={
              <Typography>
                For reference or more details, check out Y Combinator's site&nbsp;
                <ExternalLink.Text href="https://www.ycombinator.com/documents/">here</ExternalLink.Text>
                .
              </Typography>
            }
            thumbnailFilename="legal_safe_note.png"
            apiFileData={getApiFileData('SAFE Note Term Sheet')}
            height={240}
            layoutVariant="document" />
        </Grid>
      </Grid>
    </Box>
  );
};
